import { TextField } from "@mui/material";

export const RequiredTextField = (props) => (
  <TextField
    {...props}
    required
    InputLabelProps={{
      ...props.InputLabelProps,
      required: true,
      sx: {
        "& .MuiInputLabel-asterisk": {
          color: "red",
        },
      },
    }}
  />
);


